<template>
  <base-section
    id="theme-features"
    class="text-center"
    space="56"
  >
    <base-icon class="mb-8">
      mdi-eye-check-outline
    </base-icon>
    <base-section-heading title="간편하고 직관적인 사용">
      스마트폰 전용 어플리케이션으로 터치하면 입력 끝!
    </base-section-heading>

    <v-container>
      <v-row>
        <v-col cols="12">
          <v-img
            :src="require('@/assets/diagram-2.svg')"
            class="mx-auto mb-8"
            max-width="1000"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          언제, 어디서든, 누구나 스마트폰만 있으면 간편하게 FLAG App을 통해 담당하는 설비 점검/운전 정보를 입력할 수 있습니다.
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionThemeFeatures',

    data: () => ({

    }),
  }
</script>
